import React from 'react';
import createForm from "./Form";
import CheckBox from "../../form/CheckBox";
import ComponentField from "../../form/ComponentField";

class ProgramTypeForm extends React.Component<any, any> {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />
                    </div>
                    <div className="col-md-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="vat"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Áfa"
                        />
                    </div>
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="description"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Leírás"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <CheckBox
                                name="config.ticketable"
                                type="bool"
                                value={this.props.values.config?.ticketable}
                                saveChanges={(field, value) => this.props.setFieldValue(field, value ? 1 : 0)}
                                label="Lehetséges a jegy eladás"
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <CheckBox
                                name="config.single_event"
                                type="bool"
                                value={this.props.values.config?.single_event}
                                saveChanges={(field, value) => this.props.setFieldValue(field, value ? 1 : 0)}
                                label="Egyszeri esemény"
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(ProgramTypeForm);
